import { Pipe, PipeTransform } from '@angular/core';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Utils } from 'src/app/utils.class';

@Pipe({
    name: 'MechanicHasPlanning',
    standalone: false,
})
export class MechanicHasPlanningPipe implements PipeTransform {
    transform(planningHass: PlanningHasEntity[], mechanicId: number, trigger?: any): PlanningHasEntity[] {
        return planningHass
            ?.filter(
                ph =>
                    ph.mechanics.map(m => m.mechanic_id).includes(mechanicId) ||
                    (ph.mechanics.map(m => m.sec_mechanic_id).includes(mechanicId) && !!mechanicId) ||
                    (!mechanicId && mechanicId !== 0 && ph.mechanics?.length < 1)
            )
            .sort((a, b) => Utils.getTimeOrNull(a.begindate) - Utils.getTimeOrNull(b.begindate));
    }
}
